module.exports = __webpack_public_path__ + "img/shop.51dadb0b.png";